import Lenis from 'lenis';
import gsap from 'gsap';
import { scrollInstance } from './main';
import { detectedDevice } from 'detected-device';
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const customScrollPage = () => {
	const customScroll = new Lenis({
		duration: 1.2,
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
		direction: 'vertical', // vertical, horizontal
		gestureDirection: 'vertical', // vertical, horizontal, both
		smooth: true,
		smoothWheel: true,
		wheelMultiplier: 1,
		mouseMultiplier: 1,
		smoothTouch: false,
		touchMultiplier: 30,
		infinite: false,
		//prevent: (node) => node.classList.contains('select2-results__options') //Checkout select
	})

	customScroll.on('scroll', ScrollTrigger.update);

	gsap.ticker.add((time) => {
		customScroll.raf(time * 1000);
	});
	gsap.ticker.lagSmoothing(0);

	return customScroll
}

const lazyLoadImages = (element) => {
	let lazyEls = element.querySelectorAll('.lazy');
	[...lazyEls].forEach((lazyEl) => {
		if(lazyEl.tagName == 'PICTURE'){
			let img = lazyEl.querySelector('img');
			let src = img.dataset.src;
			img.setAttribute('src', src);
			img.removeAttribute('data-src');
			let sources = lazyEl.querySelectorAll('source');
			[...sources].forEach((source) => {
				let srcset = source.dataset.srcset;
				source.setAttribute('srcset', srcset);
				source.removeAttribute('data-srcset');
			})
			lazyEl.classList.remove('lazy');
			element.classList.add('lazyloaded');
		}
	})
}

const scrollLazyLoad = (scrollInstance) => {
	let lazyOffset = window.innerHeight*1.3;
	let lazyElements = document.querySelectorAll('.element-lazyload');
	
	if(lazyElements.length > 0) {

		lazyElements.forEach((lazyEl, index) => {
			if(index < 4){
				lazyLoadImages(lazyEl)
			}
		})

		scrollInstance.on('scroll', () => {

			lazyElements.forEach((lazyEl) => {
				if(!lazyEl.classList.contains('lazyloaded')){
					let bound = lazyEl.getBoundingClientRect();
					if(bound.y < lazyOffset){
						lazyLoadImages(lazyEl)
					}
				}
			})

		})
	}
}

const scrollHeader = () => {
	if(detectedDevice.isAllMobileDevices()) return;
	
	if(scrollInstance.animatedScroll > 100){
		document.querySelector('header').classList.add('scrolled')
	}else{
		document.querySelector('header').classList.remove('scrolled')
	}

	scrollInstance.on('scroll', () => {
		if(scrollInstance.animatedScroll > 0 && scrollInstance.direction == 1){ //scroll down
			document.querySelector('header').classList.add('scrolled')
			if(scrollInstance.animatedScroll > 180){
				gsap.to(document.querySelector('header .header--bg'), { y: '0%', duration: 0.4 })
			}
		}else{
			document.querySelector('header').classList.remove('scrolled')
			if(scrollInstance.animatedScroll < 100 && scrollInstance.direction == -1){ //scroll up
				if(scrollInstance.animatedScroll < 180){
					gsap.to(document.querySelector('header .header--bg'), { y: '-100%', duration: 0.4 })
				}
			}
		}
	})
}

function handleScrollTarget() {
    const targetId = sessionStorage.getItem('scrollTarget');
    if (!targetId) return;

    sessionStorage.removeItem('scrollTarget'); // consuma subito

    const target = document.getElementById(targetId);
    if (!target) return;

    // Aspetta che Lenis sia pronto e la transizione Swup sia finita
    setTimeout(() => {
        scrollInstance.scrollTo(target, { duration: 2 });
    }, 300);
}

export { customScrollPage, scrollLazyLoad, scrollHeader, handleScrollTarget }